import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
// Import React FilePond
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import { registerPlugin } from "react-filepond";

// Import the plugin code
import { Cross2Icon } from "@radix-ui/react-icons";
import FilePondPluginImageResize from "filepond-plugin-image-resize";
import { HOME } from "../../Utils/Utils";
import { ActivationEnLigne } from "../../components/Ajouter-intention/ActivationEnLigne";
import { AfficherSouscription } from "../../components/Ajouter-intention/AfficherSouscription";
import { CollectePaiement } from "../../components/Ajouter-intention/CollectePaiement";
import { DemandeIntention } from "../../components/Ajouter-intention/DemandeIntention";
import { Eligibilite } from "../../components/Ajouter-intention/Eligibilite";
import { IndentificationClient } from "../../components/Ajouter-intention/IndentificationClient";
import InstallationUnifiee from "../../components/Ajouter-intention/Installation";
import { LivraisonForm } from "../../components/Ajouter-intention/Livraison";
import { PriseRendezVous } from "../../components/Ajouter-intention/PriseRendezVous";
import { SouscriptionTest } from "../../components/Ajouter-intention/SouscriptionTest";
import { ValidationRaccordement } from "../../components/Ajouter-intention/ValidationRaccordement";
import { ValidationSurvey } from "../../components/Ajouter-intention/ValidationSurvey";
// Register the plugins
registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginImageResize,
);
// eslint-disable-next-line import/first
// eslint-disable-next-line import/first
// eslint-disable-next-line import/first

const steps = [
  "Verification d'éligilité",
  "Enregistrer une intention",
  "Collecte de paiement",
  "Livraison de l équipement",
  "Identification du client",
  "Prise de rendez-vous",
  "Survey",
  // "Rendez-vous de raccordement",
  // "Raccordement",
  "Installation",
  // "Souscription forfait",
  "Test de connectivité",
];

const EditIntention = () => {
  const [skipped, setSkipped] = useState(new Set());
  const { id, step } = useParams();
  const isStepSkipped = (step) => {
    return skipped.has(step);
  };
  const [activeStep, setActiveStep] = useState(Number(step));
  const location = useLocation();

  useEffect(() => {
    localStorage.removeItem("numeroTicket");
  }, [location]);

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
    navigate(
      `${
        HOME + "/" + location.pathname.split("/")[2]
      }/poursuivre-intention/${id}/${activeStep}`,
    );
  };
  const navigate = useNavigate();
  return (
    <div className="relative pb-32 mb-20">
      <dialog id="delete_batiment" className="modal">
        <div className="modal-box max-w-md rounded-lg">
          <h3 className="font-extrabold text-xl text-red-600 ">Attention</h3>
          <p className="pt-2 text-black font-medium">
            Voulez vous des modifications en cours ?
          </p>
          <div className="modal-action">
            <form
              method="dialog"
              className="w-full flex items-center justify-end gap-x-4"
            ></form>
          </div>
        </div>
      </dialog>
      <button
        onClick={() => {
          window.history.back();
          localStorage.removeItem("numeroTicket");
        }}
        className="lg:hidden md:hidden xl:hidden bg-red-50 text-red-700 w-10 h-10 flex items-center justify-center rounded-full"
      >
        <Cross2Icon className="w-6 h-6" />
      </button>

      <button
        onClick={() => {
          window.history.back();
          localStorage.removeItem("numeroTicket");
        }}
        className="absolute top-0 right-8 hidden lg:flex md:flex xl:flex btn-circle btn btn-sm  items-center justify-center btn-error text-white hover:text-black"
      >
        <Cross2Icon />
      </button>
      <div className="lg:px-6 lg:py-2 h-screen flex xl:flex-row lg:flex-row md:flex-row flex-col gap-8 w-full mx-auto">
        <div className="md:w-[20%] lg:w-[20%] xl:w-[20%] lg:h-[77.5vh] md:h-[77.5vh] xl:lg:h-[77.5vh] w-full flex flex-col justify-between pb-1">
          <div className="hidden md:block lg:block xl:block">
            <ul className="steps steps-vertical">
              {steps.map((label, index) => (
                <li
                  data-content={`${index < activeStep ? "✓" : index + 1} `}
                  className={`step  ${
                    index < activeStep ? "step-warning" : ""
                  }`}
                >
                  <p className="text-xs">{label}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pb-8 flex flex-col w-full lg:w-[57%]">
          {activeStep === 0 ? (
            <Eligibilite handleNext={handleNext} />
          ) : activeStep === 1 ? (
            <DemandeIntention handleNext={handleNext} numero={id} />
          ) : activeStep === 2 ? (
            <CollectePaiement numeroTicket={id} handleNext={handleNext} />
          ) : activeStep === 3 ? (
            <LivraisonForm numeroTicket={id} handleNext={handleNext} />
          ) : activeStep === 4 ? (
            <IndentificationClient numeroTicket={id} handleNext={handleNext} />
          ) : activeStep === 5 ? (
            <PriseRendezVous numeroTicket={id} />
          ) : activeStep === 6 ? (
            <ValidationSurvey numeroTicket={id} />
          ) : activeStep === 9 ? (
            <ActivationEnLigne numeroTicket={id} />
          ) : activeStep === 7 ? (
            <InstallationUnifiee numeroTicket={id} />
          ) : activeStep === 11 ? (
            <ValidationRaccordement numeroTicket={id} handleNext={handleNext} />
          ) : activeStep === 10 ? (
            <AfficherSouscription numeroTicket={id} handleNext={handleNext} />
          ) : activeStep === 8 ? (
            <SouscriptionTest numeroTicket={id} />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default EditIntention;
